import { Component, OnInit, NgZone, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
declare const Swal;

@Component({
  selector: 'app-edit-branch',
  templateUrl: './edit-branch.component.html',
  styleUrls: ['./edit-branch.component.css']
})
export class EditBranchComponent implements OnInit {

  @ViewChild('modalHide') modalHide;
  
  public editBranchForm:FormGroup;
  public branchObj={};
  public branchLocation={};
  public selectedValueClose = false;
  public locationSuggestions={};
  public firstLoadLocation:boolean=true;

  primaryMap: any;
  mapSearchDebounceTimeOut = null;
  mapSearchDataLists = [];
  markerId = 'branchLocation';

  public editLocation:boolean=true;
  public locationData = {};
  formSubmit:boolean=false;

  public orgID;
  public branchID;
  public updateValues=[];
  public updateLocation:boolean=false;

  public editBranchFormSubmitted:boolean=false;
  public selectedMap:string='osrm';
  
  public disableLocation:boolean=true;

  //geofence
  public pickupRadiusCircle:any;
  public isLoctionMarked:boolean=false;
  public geofenceRadius:number;
  public markedlocations:any=[];
  public isMultipleGeo:boolean=false;

  //radius error
  public isRadiusGreater:boolean=false;
  public radiusError:string='';
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    public storage: StorageService,
    public router: Router,
    public ngZone:NgZone) { 
      this.orgID = this.storage.get('userInfo').orgID;
      this.route.paramMap.subscribe((params: any) => {
        this.branchID = params.params.branchID;  
      });
      let user = this.storage.get('userInfo');
      if(user && user.map){
        this.selectedMap = user.map;
      }
    }
    
  ngOnInit(): void {
    this.editBranchLoad();
    this.getBranchData();
  }
  editBranchLoad(){
    this.editBranchForm = new FormGroup({
      branchName: new FormControl('', [Validators.required,Validators.pattern(/^([A-Za-z0-9 ])+(?:\.[a-zA-Z0-9]+?)*$/)]),
      location: new FormControl('', [Validators.required]),
      isDefault: new FormControl(''),
      isNodalBranch: new FormControl(false),
      radius: new FormControl('', [Validators.required]),
    });
  }
  formatName(){
    let branchName=this.editBranchForm.value.branchName.replace(/ {2,}/g,' ').trim();
    this.editBranchForm.patchValue({
      branchName:branchName
    })
    }
  getBranchData(){
    const obj = {
        orgID: this.orgID,
        branchID: this.branchID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
        if (res.status == 'success') {
            if (res.data.length>0){
              let data=res.data.find((e)=>e.branchID==this.branchID);
              this.branchObj=data;
              data['editTrue'] = 'noEdit';
              this.markedlocations.push(data);
              this.setValueEditBranchForm(data);
            }
        }  
    }).catch((err) => {
        console.log(err);
    });
  }

  setValueEditBranchForm(data){
    this.geofenceRadius=data.radius;
    this.editBranchForm.patchValue({
      branchName: data.branchName,
      location: data.location.name,
      isDefault:data.isDefault,
      isNodalBranch: !!(data.isNodal || data.isNodalBranch || data.nodalBranch),
      radius: data.radius
    });
    this.locationData = { ...data.location};
  }

  getLocation(obj){
    this.branchLocation = {...obj};
    this.fieldChange(this.branchLocation,'location','location'); 
  }

  /* checking error in fields*/
  public checkError = (controlName: string, errorName: string) => {
    return this.editBranchForm.controls[controlName].hasError(errorName);
  }
  /* update unique field*/
  fieldChange(e:any,type,field){
    if(type=='text' || type=='textarea'){
      this.updateField(field,e.target.value);
    }
    /* if(type=='date' || type=='dropdown'){
      this.updateField(field,e.value);
    } */
    if(type=='location'){
      this.updateField(field,e);
    }
    if(type=='number'){
      this.updateField(field, +e.target.value);
    }
    if(type=='checkbox'){
      this.updateField(field,e.checked);
    }
  }
  updateField(field,value){
    if(this.updateValues.length>0){
      let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
      let obj={field:field,value:value,};
      this.updateValues=[
        ...filterUpdate,
        obj,
      ]
    }
    else{
      let obj={field:field,value:value,};
      this.updateValues.push(obj);
    }
  }
  radiusValidation(e){
    this.fieldChange(e,'number','radius');
    this.geofenceRadius=this.editBranchForm.value.radius;
    let radiusField=document.getElementById('radiusField');
    if(this.editBranchForm.value.radius<=25 && this.editBranchForm.value.radius>0 && this.editBranchForm.value.radius!=null){
      this.isRadiusGreater=false;
      radiusField.classList.remove('mat-form-field-invalid');
      radiusField.classList.remove('ng-invalid');
      radiusField.classList.add('ng-valid');
      this.radiusError='';
    }else if(this.editBranchForm.value.radius==null){
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.isRadiusGreater=false;
      this.radiusError='';
    }else if(this.editBranchForm.value.radius==0){
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError='Radius must be above 0KM';
      this.isRadiusGreater=true;
    }else{
      radiusField.classList.add('mat-form-field-invalid');
      radiusField.classList.add('ng-invalid');
      radiusField.classList.remove('ng-valid');
      this.radiusError='Radius limits upto 25KM';
      this.isRadiusGreater=true;
    }
  }
  getSelectedLocation(obj){
    this.branchLocation={...obj};
    if (this.branchLocation['condition'] == '') {
      this.fieldChange(this.branchLocation, 'location', 'location');
    }
    if(this.branchLocation && this.branchLocation['name'] && this.branchLocation['name']!=''){
      this.editBranchForm.patchValue({
        location : this.branchLocation['name']
      })
    }
  }
  /* Delete Data*/
  delete() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor:  '#d33',//'#3085d6',
      //  cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteBranch();
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // );
      }
    });
  }
  deleteBranch() {
    const obj = {
      orgID: this.orgID,
      branchID: this.branchID
    };
    this.api.transportManagerBranchDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 20000);
        this.router.navigate(['/organization/transport-manager/information/orgInfo/branch/view-branch']);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 20000);
      }
    });
  }
  /* Cancel Edit*/
  cancel(){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/branch/view-branch']);
  }
  /* Submit Data*/
  onSubmit(){
    this.formSubmit = true;
    this.editBranchFormSubmitted = true;
    if(this.selectedMap=='google'){
      // this.radiusValidation();
    }
    if(this.updateValues && this.updateValues.length>0 && (this.editBranchForm.valid && this.selectedMap!='google' || this.editBranchForm.valid && this.selectedMap=='google' && !this.isRadiusGreater)){
      const obj = {
        orgID: this.storage.get('userInfo').orgID,
        branchID:this.branchID,
      };
      this.updateValues.filter((e)=>{
        obj[e.field]=e.value;
        if (e.field === 'isNodalBranch') {
          obj['isNodal'] = e.value;
        }
            /* if(e.field=='location'){
              obj[e.field] = {
                lat: e.value.lat,
                lng: e.value.lng,
                name: e.value.name,
              };
            }
            else{
              obj[e.field]=e.value;
            } */
      });
      this.api.transportManagerBranchUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/branch/view-branch'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }
}
